import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PrivacyPolicy from "../pages/legal/PrivacyPolicy";
import CookiesPolicy from "../pages/legal/CookiesPolicy";
import LegalNotice from "../pages/legal/LegalNotice";
import ArmariosCorredera from "../pages/productos/armarios-corredera/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/productos/armarios-corredera",
    element: <ArmariosCorredera />,
  },
  {
    path: "/politica-privacidad",
    element: <PrivacyPolicy />,
  },
  {
    path: "/politica-cookies",
    element: <CookiesPolicy />,
  },
  {
    path: "/aviso-legal",
    element: <LegalNotice />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
